import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

function HelpTooltip({ text, size = 'small', ...props }) {
  return (
    <Tooltip title={text} arrow {...props}>
      <IconButton size={size} sx={{ p: 0.25 }} aria-label="help" color="info">
        <HelpOutlineIcon fontSize={size === 'small' ? 'small' : 'medium'} color="info" />
      </IconButton>
    </Tooltip>
  );
}

export default HelpTooltip;